import React from 'react';
import { useGame } from '../GameContext';
import './LoadingWrapper.css';

interface LoadingWrapperProps {
  children: React.ReactNode;
}

const LoadingWrapper: React.FC<LoadingWrapperProps> = ({ children }) => {
  const { loading, error, refreshGameState } = useGame();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading game state from backend...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>⚠️ Connection Error</h2>
        <p className="error-message">{error}</p>
        <div className="error-actions">
          <button onClick={refreshGameState} className="retry-button">
            Retry Connection
          </button>
          <div className="error-help">
            <p><strong>Make sure the backend is running:</strong></p>
            <pre>cd raid-game-backend && make run</pre>
            <p>Backend should be available at: <code>http://localhost:8080</code></p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default LoadingWrapper;
